import { BaseDictionarySingleton } from '../entities.js';
import server from 'server2';

import { dictionaryExporter } from '../helpers';

class feedbackModalDataDictionary extends BaseDictionarySingleton {
	update () {
		return server.any.api.get([
			'calculatorFeedback',
			'data',
		]).then(response => {
			const { responseJSON } = response;

			this._data(responseJSON);

			return responseJSON;
		});
	}
}

export default dictionaryExporter(feedbackModalDataDictionary);
